import React, {Component} from 'react'
import {Grid, Col, Row} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {browserHistory, Link} from 'react-router'
import {Form} from 'react-form'
import LoginForm from './LoginForm'
import ErrorHandler from '../../utils/ErrorHandler'
import showToastr from '../../utils/showToastr'
import validateLogin from '../../utils/validateLogin'
import './Layout/Login.css'

class LoginScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      message: {type: '', context: ''},
      user: {
        username: '',
        password: ''
      },
      isLoading: false
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit (values) {
    this.setState({isLoading: true})
    Actions.login(values).then((res) => {
      this.setState({isLoading: false})
      showToastr('success', 'ورود', 'با موفقیت به سیستم وارد شدید')
      Actions.userInfo().then(() => browserHistory.push('/user/dashboard'))
    }).catch((err) => {
      let eh = new ErrorHandler(err)
      this.setState({message: eh.message, isLoading: false})
      eh.setFormErrors(this.refs.loginForm)
      eh.showToastrIn('ورود')
    })
  }

  render () {
    const { message, user, isLoading } = this.state
    return (
      <Grid fluid>
        <Row className="FormWrapper">
          <Col lg={4} lgOffset={4} md={6} mdOffset={3} sm={8} smOffset={2} xs={12} xsOffset={0} className="Box">
            <h1 className="FormTitle">ورود</h1>
            {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}
            <Form
              ref="loginForm"
              values={user}
              validate={validateLogin}
              onSubmit={this.onSubmit}
              isLoading={isLoading}
              disable={isLoading}>
              {LoginForm}
            </Form>
            <Col xsOffset={4} xs={7} className="signup-link">
              <span>کاربر جدید هستید؟ </span>
              <Link to="/signup" >
                ثبت نام کنید
              </Link>
            </Col>
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default LoginScreen



// WEBPACK FOOTER //
// ./src/components/Login/LoginScreen.js